 import React, { useEffect,useState } from "react";
import { motion,AnimatePresence } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { AppDispatch, RootState } from "../redux/store";

// Assets
import heroHQ from "../assets/cosmos/tv.png";
import logoImg from "../assets/cosmeta/logo.png";
import proImg from "../assets/cosmos/tv.png";


import SmartFooter from "../GLOBAL/SmartFooter";
import { useDispatch } from "react-redux";
import { fetchTotalUsers } from "../redux/authSlice";
import CountUp from "react-countup";

//import SmartFooter from "../../HOSTING/SmartFooter";
//import AppLive from "./AppLive";




const HomeLive: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
const user = useSelector((state: RootState) => state.auth.user);
const authLoaded = useSelector((state: RootState) => state.auth.authLoaded);
const [appsOpen, setAppsOpen] = useState(false);
const userInitial =
  user?.firstName?.charAt(0).toUpperCase() ?? "";
const totalUsers = useSelector((state: RootState) => state.auth.totalUsers);

  const goldGradient =
  "linear-gradient(135deg, #00275fff 0%, #1a4fa3 50%, #FEBA02 100%)";


useEffect(() => {
  dispatch(fetchTotalUsers());

  const interval = setInterval(() => {
    dispatch(fetchTotalUsers());
  }, 60000); // every 60 seconds

  return () => clearInterval(interval);
}, [dispatch]);



    useEffect(() => {
  // ⛔️ Do nothing until Firebase auth state is restored
  if (!authLoaded) return;

  // ✅ User is authenticated → redirect
  if (user) {
    navigate("/", { replace: true });
  }
}, [authLoaded, user, navigate]);

  return (
    <div
      style={{
        backgroundColor: "#000",
        minHeight: "100vh",
        color: "#fff",
        fontFamily: "Poppins, sans-serif",
        overflowX: "hidden",
      }}
    >

 
    {/* LOGO LEFT */}
    <div
      onClick={() => navigate("/")}
      style={{
        position: "fixed",
top: "calc(env(safe-area-inset-top) + 18px)",
        left: 30,
        zIndex: 4000,
        cursor: "pointer",
        padding: 3,
        borderRadius: 18,
        background: goldGradient, // ✅ gradient border
      }}
    >
      <div
        style={{
          background: "#000", // ✅ black background
          borderRadius: 16,
          padding: 10,
        }}
      >
        <img
          src={logoImg}
          alt="ARMERIX"
          style={{
            width: 38,
            height: 38,
            objectFit: "contain",
          }}
        />
      </div>
    </div>


      {/* 9 DOT MENU BUTTON */}
{/* 9 DOT MENU BUTTON */}
<div
  onClick={() => setAppsOpen(prev => !prev)}
  style={{
    position: "fixed",
top: "calc(env(safe-area-inset-top) + 18px)",
    right: 90,
    zIndex: 4000,
    cursor: "pointer",
    background: "rgba(0, 225, 255, 0.53)",
    backdropFilter: "blur(6px)",
    padding: 14,
    borderRadius: "50%",
  }}
>
  <div
    style={{
      display: "grid",
      gridTemplateColumns: "repeat(3,8px)",
      gap: 6,
    }}
  >
    {Array.from({ length: 9 }).map((_, i) => (
      <div
        key={i}
        style={{
          width: 8,
          height: 8,
          borderRadius: "50%",
          background: "#ffffff", // 🔥 WHITE
        }}
      />
    ))}
  </div>
</div>

{/* PROFILE ICON RIGHT */}
{authLoaded && user && (
  <div
    onClick={() => navigate(`/profile/${user.userId}`)}
    style={{
      position: "fixed",
top: "calc(env(safe-area-inset-top) + 18px)",
      right: 30,
      zIndex: 4000,
      cursor: "pointer",
      padding: 3,
      borderRadius: "50%",
      background: goldGradient, // gradient border
    }}
  >
    <div
      style={{
        width: 44,
        height: 44,
        borderRadius: "50%",
        background: "#000",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
      }}
    >
      {user.profilePicture ? (
        <img
          src={user.profilePicture}
          alt={user.firstName}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />
      ) : (
        <span
          style={{
            color: "#fff",
            fontWeight: 700,
            fontSize: 16,
          }}
        >
          {userInitial}
        </span>
      )}
    </div>
  </div>
)}


      {/* HERO */}
{/* HERO */}
<div
  style={{
    position: "relative",
    height: "75vh",
    paddingTop: 200,   // ⭐ THIS creates header breathing space
  }}
>        <img
          src={heroHQ}
          alt="COSMETA "
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            filter: "brightness(70%)",
          }}
        />

        {/* Gradient Overlay */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            background:
              "linear-gradient(to bottom, rgba(0,0,0,0.2), rgba(0,0,0,0.95))",
          }}
        />


        {/* Hero Content */}
        <div
          style={{
            position: "absolute",
            bottom: 60,
            left: 50,
            maxWidth: 650,
          }}
        >
          <motion.span
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            style={{
              background: goldGradient,
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              fontWeight: 900,
              letterSpacing: 2,
              fontSize: 14,
            }}
          >
            NOW LIVE
          </motion.span>

          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9 }}
            style={{
              fontSize: "clamp(34px,5vw,64px)",
              fontWeight: 800,
              marginTop: 10,
              color: "#fff",
              textShadow: "0 6px 18px rgba(0,0,0,0.7)",
            }}
          >
            COSMETA GLOBAL
            <br />
           Experience
          </motion.h1>

          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3 }}
            style={{
              color: "#cfcfcf",
              fontSize: 16,
              lineHeight: 1.6,
              marginTop: 16,
              maxWidth: 520,
            }}
          >
            Electronics. Curated Shops.
          </motion.p>



<motion.div
  initial={{ opacity: 0 }}
  animate={{ opacity: 1 }}
  transition={{ duration: 1 }}
  style={{
    marginTop: 70,
    position: "relative",
  }}
>
  {/* HEAVEN GLOW BACKDROP */}
  <div
    style={{
      position: "absolute",
      top: -150,
      left: "50%",
      transform: "translateX(-50%)",
      width: 600,
      height: 600,
      background:
        "radial-gradient(circle, rgba(10,102,194,0.35) 0%, rgba(255,255,255,0.15) 40%, transparent 75%)",
      filter: "blur(140px)",
      zIndex: -1,
    }}
  />

  {/* FALLING NUMBER */}
  <motion.div
    initial={{ y: -300, opacity: 0, scale: 0.8 }}
    animate={{ y: 0, opacity: 1, scale: 1 }}
    transition={{
      type: "spring",
      stiffness: 80,
      damping: 12,
      duration: 1.5,
    }}
    style={{
      fontSize: "clamp(80px, 10vw, 180px)",
      fontWeight: 900,
      lineHeight: 1,
      background: goldGradient,
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
      letterSpacing: 4,
      textAlign: "left",
      filter: "drop-shadow(0 30px 80px rgba(255,255,255,0.25))",
      textShadow: `
        0 5px 15px rgba(0,0,0,0.6),
        0 20px 60px rgba(255,255,255,0.12),
        0 40px 100px rgba(10,102,194,0.25)
      `,
    }}
  >
    <CountUp
      end={totalUsers}
      duration={2.5}
      separator=","
    />
  </motion.div>

  {/* SELLERS TRUST US */}
  <motion.div
    initial={{ opacity: 0, y: 30 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ delay: 1 }}
    style={{
      marginTop: 30,
      fontSize: 28,
      fontWeight: 900,
      letterSpacing: 6,
      color: "#ffffff",
      textTransform: "uppercase",
    }}
  >
    USERS TRUST US
  </motion.div>

  {/* SUBTITLE */}
  
    <motion.div
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    transition={{ delay: 1.2 }}
    style={{
      marginTop: 14,
      fontSize: 18,
      color: "rgba(255,255,255,0.65)",
      fontWeight: 500,
    }}
  >
   Building  World's Leading Seller-Buyer Platform
  </motion.div>
  
 

</motion.div>



<motion.button
  whileHover={{ scale: 1.05 }}
  whileTap={{ scale: 0.96 }}
  onClick={() => {
    if (authLoaded && user?.userId) {
      navigate(`/commerceonboarding/${user.userId}`);
    } else {
      navigate("/authswitch");
    }
  }}
  style={{
    marginTop: 24,
    background: goldGradient,
    color: "#000",
    border: "none",
    padding: "14px 30px",
    fontWeight: 800,
    fontSize: 15,
    cursor: "pointer",
    boxShadow: "0 10px 30px rgba(191,155,48,0.45)",
  }}
>
  Become A Seller
</motion.button>


        </div>
      </div>



      {/*===============================================================================================================================*/}
      
      {/* INCLUSIVE PRICING / COMPARISON */}
      <motion.section
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        style={{
          maxWidth: 1200,
          margin: "140px auto",
          padding: "0 20px",
        }}
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1.3fr",
            gap: 80,
            alignItems: "flex-start",
          }}
        >
      
          {/* LEFT SIDE */}
          <div>
            <h2 style={{
              fontSize: 44,
              fontWeight: 900,
              lineHeight: 1.1,
              marginBottom: 20,
            }}>
              Keep more of what you earn
            </h2>
      
            <p style={{
              color: "#bfbfbf",
              fontSize: 18,
              lineHeight: 1.7,
              maxWidth: 420,
            }}>
              Traditional platforms take large commissions and leave hosts handling
              refunds, disputes and payouts. COSMETA automates everything and lets you
              keep your earnings  with protection built in.
            </p>
          </div>
      
      
          {/* RIGHT SIDE TABLE */}
          <div>
      
            {/* TABLE HEADER */}
            <div style={{
              display: "grid",
              gridTemplateColumns: "2fr 1fr 1fr",
              paddingBottom: 16,
              borderBottom: "1px solid rgba(255,255,255,0.15)",
              fontSize: 13,
              letterSpacing: 1,
              color: "#aaa",
              fontWeight: 700
            }}>
              <div>FEATURES</div>
              <div style={{ textAlign:"center", color:"#e6c35c" }}>COSMETA</div>
              <div style={{ textAlign:"center" }}>OTHERS</div>
            </div>
      
      
            {/* ROWS */}
            {[
              ["0% commission on orders", true],
              ["No hosting or listing fees", true],
              ["We bring guests & marketing", true],
              ["Automatic payouts & earnings tracking", true],
              ["Automatic  refunds", true],
              ["Secure payments & VAT handled", true],
              ["Automated refunds & gifts", true],
              ["Real-time Ordering,tracking & payout tracking", true],
              ["Hidden fees", "included"],
            ].map((row:any, i) => (
              <div
                key={i}
                style={{
                  display: "grid",
                  gridTemplateColumns: "2fr 1fr 1fr",
                  padding: "18px 0",
                  borderBottom: "1px solid rgba(255,255,255,0.08)",
                  alignItems: "center"
                }}
              >
                <div style={{ color:"#e6e6e6" }}>{row[0]}</div>
      
                {/* ARELUXE */}
                <div style={{ textAlign:"center", color:"#e6c35c", fontSize:20 }}>
                  {row[1] === "included" ? "None" : "✓"}
                </div>
      
                {/* OTHERS */}
                <div style={{ textAlign:"center", color:"#888", fontSize:20 }}>
                  {row[1] === "included" ? "10–30% fees" : "✕"}
                </div>
              </div>
            ))}
      
          </div>
        </div>
      
        {/* MOBILE STACK */}
        <style>
          {`
            @media(max-width:900px){
              section > div{
                grid-template-columns:1fr !important;
                gap:50px !important;
              }
            }
          `}
        </style>
      </motion.section>
      
      
      
      {/* WHY CHOOSE ARELUXE */}
      <motion.section
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        style={{
          maxWidth: 1200,
          margin: "140px auto",
          padding: "0 20px",
        }}
      >
      
        {/* TITLE */}
        <h2 style={{
          fontSize: 42,
          fontWeight: 900,
          marginBottom: 20
        }}>
          Why choose COSMETA?
        </h2>
      
        <p style={{
          color:"#bfbfbf",
          fontSize:18,
          lineHeight:1.7,
          maxWidth:780,
          marginBottom:80
        }}>
          COSMETA removes the risk, admin and hidden fees from hosting. 
          Everything is automated;from payments and cancellations to payouts 
          and buyer communication so you can focus on earning, not managing.
        </p>
      
        {/* TOP FEATURE GRID */}
        <div style={{
          display:"grid",
          gridTemplateColumns:"repeat(auto-fit,minmax(260px,1fr))",
          gap:50,
          marginBottom:100
        }}>
      
          <div>
            <h4 style={{fontWeight:800,fontSize:20,marginBottom:8}}>
              Smart cancellation protection
            </h4>
            <p style={{color:"#bfbfbf",lineHeight:1.6}}>
              Choose from 2 cancellation policies with automatic refunds            </p>
          </div>
      
          <div>
            <h4 style={{fontWeight:800,fontSize:20,marginBottom:8}}>
              Automatic payouts & earnings tracking
            </h4>
            <p style={{color:"#bfbfbf",lineHeight:1.6}}>
              Real-time earnings dashboard, future payout forecasting and 
              automatic transfers no spreadsheets required.
            </p>
          </div>
      
          <div>
            <h4 style={{fontWeight:800,fontSize:20,marginBottom:8}}>
              Secure payments & tax handling
            </h4>
            <p style={{color:"#bfbfbf",lineHeight:1.6}}>
              Buyers pay securely with Stripe. VAT, cards, refunds and 
              transactions are handled automatically.
            </p>
          </div>
      
          <div>
            <h4 style={{fontWeight:800,fontSize:20,marginBottom:8}}>
              Marketing that brings Sales
            </h4>
            <p style={{color:"#bfbfbf",lineHeight:1.6}}>
              Your Product is promoted and discoverable, we focus on bringing 
              buyers so you focus on selling.
            </p>
          </div>
        </div>
      
      
        {/* SECURITY WITHOUT COMPROMISE */}
        <div style={{
          display:"grid",
          gridTemplateColumns:"repeat(auto-fit,minmax(320px,1fr))",
          gap:60
        }}>
          
          <div>
            <h3 style={{ fontSize:30, fontWeight:800, marginBottom:18 }}>
              Security without compromise
            </h3>
      
            <p style={{ color:"#bfbfbf", lineHeight:1.7 }}>
              Selling should feel safe and effortless. COSMETA protects both 
              hosts and guests with automated safeguards, transparent payments 
              and real-time order tracking.
            </p>
          </div>
      
          <div style={{ display:"grid", gap:30 }}>
       
      
            <div>
              <h4 style={{ fontWeight:800 }}>Verified users & secure orders</h4>
              <p style={{ color:"#bfbfbf" }}>
                Secure payments and verified accounts keep every booking 
                safe and trustworthy.
              </p>
            </div>
      
            <div>
              <h4 style={{ fontWeight:800 }}>Real-time Order tracking</h4>
              <p style={{ color:"#bfbfbf" }}>
                Activity logs, notifications and booking updates keep you 
                fully informed and in control.
              </p>
            </div>
      
          </div>
        </div>
      
      </motion.section>
      
      
      
      {/*============================================================================================*/}

      {/* VIDEO SECTION */}
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        style={{
          maxWidth: 1100,
          margin: "80px auto",
          padding: "0 20px",
        }}
      >
        <h2
          style={{
            textAlign: "center",
            color: "#5ccae6ff",
            fontSize: 32,
            fontWeight: 800,
            marginBottom: 30,
          }}
        >
          Join The YouTube Community
        </h2>

        <div
          style={{
            position: "relative",
            paddingTop: "56.25%",
            borderRadius: 22,
            overflow: "hidden",
            border: "1px solid rgba(191,155,48,0.35)",
            boxShadow:
              "0 25px 70px rgba(0,0,0,0.85), 0 0 35px rgba(191,155,48,0.3)",
          }}
        >

          <iframe
  src="https://www.youtube.com/embed?listType=playlist&list=UCMiGzf7FkjM5_RZEoYYszMg"
  title="COSMETA Channel"
  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
  allowFullScreen
  style={{
    position: "absolute",
    inset: 0,
    width: "100%",
    height: "100%",
    border: "none",
  }}
/>
        </div>
      </motion.div>



     
{/*         
<AppLive />
 */}       

      {/* SEPARATOR */}
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          margin: "80px 0",
        }}
      >
        <div
          style={{
            width: "60%",
            height: 2,
            background:
              "linear-gradient(90deg, transparent, #3075bfff, transparent)",
          }}
        />
      </div>

      {/* FOOTER 
          

      
      */}

        <SmartFooter />

      {/* FLOATING APPS MENU */}
{/* FLOATING APPS MENU */}
<AnimatePresence>
  {appsOpen && (
    <motion.div
      initial={{ opacity: 0, scale: 0.9, y: -20 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      exit={{ opacity: 0, scale: 0.9, y: -20 }}
style={{
  position: "fixed",
  top: 90,                     
  right: 20,                   

  width: 320,               
height: 520,               
maxHeight: "75vh",
borderRadius: 48,         

padding: "28px 22px 30px 22px",

  boxShadow:
    "0 20px 60px rgba(0,0,0,0.25), 0 5px 25px rgba(0,0,0,0.15)",

  zIndex: 4000,


  border: "1px solid rgba(255,255,255,0.35)",

}}

    >
      <h3
        style={{
          fontWeight: 800,
          marginBottom: 25,
          fontSize: 20,
          background: goldGradient,
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
        }}
      >
        Explore
      </h3>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(2,1fr)",
          gap: 24,
        }}
      >
        {/* CARD WRAPPER STYLE */}


        {/*
          {
            img: shortTermImg,
            label: "Buy Products",
            route: "/shortaccommodation",
          },
        
        */}
        {[
          {
            img: proImg,
            label: "Shopping",
            route: "/metacommerce",
          },
       
  
        
        ].map((item, index) => (
          <div
            key={index}
            onClick={() => {
              setAppsOpen(false);
              navigate(item.route);
            }}
            style={{
              cursor: "pointer",
              padding: 3,
              borderRadius: 22,
              background: goldGradient, // ✅ GRADIENT BORDER
            }}
          >
            <div
              style={{
                background: "#ffffff",
                borderRadius: 20,
                padding: 14,
                textAlign: "center",
              }}
            >
              <img
                src={item.img}
                style={{
                  width: "100%",
                  aspectRatio: "1 / 1", // ✅ PERFECT SQUARE
                  objectFit: "cover",
                  borderRadius: 16,
                }}
              />

              <div
                style={{
                  marginTop: 14,
                  padding: "6px 12px",
                  borderRadius: 12,
                  display: "inline-block",
                  background: goldGradient,
                }}
              >
                <span
                  style={{
                    fontWeight: 700,
                    fontSize: 14,
                    color: "#000",
                  }}
                >
                  {item.label}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </motion.div>
  )}
</AnimatePresence>


    </div>
  );
};

export default HomeLive;